import { createFileRoute, redirect } from '@tanstack/react-router';

import { runLineageSearchSchema } from '~/features/catalog-v2/utils/lineage-images-search';

/**
 * The old "Lineage" tab no longer exists: its listing × stage grid is now the Products tab's
 * "Listings" view, and its issues-by-reason view is the new Issues tab. This route only keeps
 * old links working — `/lineage` → Products, `/lineage?view=issues` → Issues, `/lineage?listing=`
 * → Products with that product's journey drawer open — it renders nothing of its own.
 */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/lineage')({
  validateSearch: runLineageSearchSchema,
  beforeLoad: ({ params, search }) => {
    if (search.view === 'issues') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect
      throw redirect({
        to: '/catalog-v2/runs/$runId/issues',
        params: { runId: params.runId },
        replace: true,
      });
    }
    if (search.listing) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect
      throw redirect({
        to: '/catalog-v2/runs/$runId/products',
        params: { runId: params.runId },
        search: { feedProductId: search.listing },
        replace: true,
      });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect
    throw redirect({
      to: '/catalog-v2/runs/$runId/products',
      params: { runId: params.runId },
      // A stage/status/disposition filter carries over into the relocated Listings view.
      search:
        search.stage || search.status || search.disposition
          ? {
              view: 'listings',
              ...(search.stage ? { stage: search.stage } : {}),
              ...(search.status ? { status: search.status } : {}),
              ...(search.disposition ? { disposition: search.disposition } : {}),
            }
          : {},
      replace: true,
    });
  },
});
